import {stickyBar} from "./sticky-bar";
import {searchForm} from "./search-form";

function findStickyBars() {
    for (const sb of document.querySelectorAll(".stickybar__support")) {
        stickyBar(sb);
    }
}

function main() {
    findStickyBars();
    searchForm();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
} else {
    main();
}
